import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { FunctionCategory } from './function-category.interface';
import { FunctionCategoryService } from './function-category.service';

const service = new FunctionCategoryService();

export interface FunctionCategoryState {
   functionCategories: Array<FunctionCategory>;
}

const FunctionCategoryStore: Module<FunctionCategoryState, StoreState> = {
   namespaced: true,
   state: { functionCategories: [] },
   getters: {},
   mutations: {
      SET_FUNCTION_CATEGORIES(state, functionCategories: Array<FunctionCategory>) {
         state.functionCategories = functionCategories;
      },
   },
   actions: {
      async getFunctionCategories(context, query?: LocationQuery) {
         const response = await service.getFunctionCategories(query);
         context.commit('SET_FUNCTION_CATEGORIES', response.data);
         return response.data;
      },
   },
};

export default FunctionCategoryStore;
